import { memo } from 'react';

export interface FilesPlaceholderProps {
  fileLabel: string;
  imageNoFiles: string;
  canCreate?: boolean;
  onStartCreate: () => void;
}

const FilesPlaceholder = ({ canCreate, fileLabel, imageNoFiles, onStartCreate }: FilesPlaceholderProps) => (
  <div className="text-center text-muted padding-top margin-top">
    {translate('No {{fileLabel}} uploaded.', {
      fileLabel,
    })}
    {canCreate && (
      <>
        &nbsp;
        {translate('You can upload {{fileLabel}} by', {
          fileLabel,
        })}
        &nbsp;
        <a className="margin-top" title="start upload" onClick={onStartCreate}>
          {translate('clicking here.')}
        </a>
        <br />
        {translate('Or on the "Upload {{fileLabel}}" button.', {
          fileLabel,
        })}
        <br />
      </>
    )}

    <br />
    {imageNoFiles ? <img src={imageNoFiles} alt={`No ${fileLabel}s`} className="margin-top margin-bottom" /> : null}
  </div>
);

// eslint-disable-next-line import/no-default-export
export default memo(FilesPlaceholder);
